// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  width: 240px !important;
  background-color: #2c3e50 !important; /* Dark blue from the HTML version */
  color: white !important; /* White text for better contrast on dark background */
  height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  position: relative !important;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1) !important; /* Add subtle shadow for depth */
}

.sidebar .logo {
  padding: 20px;
  text-align: center;
  background-color: #2c3e50 !important;
}

.sidebar .logo img {
  max-width: 100%;
}

.nav-options {
  padding: 20px 0;
}

.nav-option {
  padding: 12px 20px;
  cursor: pointer;
  transition: background-color 0.3s;
  font-size: 16px; /* Ensure readable font size */
  color: white; /* White text */
}

.nav-option.active {
  background-color: #34495e; /* Darker blue for active state from HTML */
  border-left: 4px solid #3498db; /* Blue accent color from HTML */
  color: white; /* Keep text white */
}

.nav-option:hover {
  background-color: #34495e !important; /* Force darker blue background */
  color: white !important; /* Force white text */
}

.profile-section {
  margin-top: auto;
  padding: 20px;
  border-top: 1px solid #34495e; /* Darker border color from HTML */
}

.profile-option {
  display: flex;
  align-items: center;
  padding: 12px 0;
  cursor: pointer;
  font-size: 18px; /* Increased font size for better readability */
  font-weight: 500; /* Slightly bolder text */
  color: white; /* White text for dark background */
}

.profile-option:hover {
  background-color: #34495e !important; /* Force darker blue background */
  color: white !important; /* Force white text */
}

.profile-option img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 12px;
}

.profile-menu-dropdown {
  position: absolute;
  bottom: 80px;
  right: 20px;
  background-color: #34495e;
  border-radius: 4px;
  padding: 8px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.menu-item {
  padding: 8px 16px;
  color: white;
  cursor: pointer;
}

.menu-item:hover {
  background-color: #2c3e50;
}

.change-password-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  border-radius: 8px;
  z-index: 1000;
  width: 300px;
  color: #2c3e50;
}

.change-password-modal input {
  display: block;
  width: 100%;
  padding: 8px;
  margin: 8px 0;
  border-radius: 4px;
  border: 1px solid #ddd;
  margin-bottom: 16px; /* Added spacing between fields */
}

.change-password-modal h3 {
  margin-top: 0;
  margin-bottom: 20px;
}

.form-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 24px; /* Increased top margin */
}

.primary-button {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.primary-button:hover {
  background-color: #2980b9;
}

.secondary-button {
  background-color: white;
  color: #2c3e50;
  border: 1px solid #ddd;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.secondary-button:hover {
  background-color: #f5f5f5;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

`, "",{"version":3,"sources":["webpack://./src/components/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,oCAAoC,EAAE,oCAAoC;EAC1E,uBAAuB,EAAE,sDAAsD;EAC/E,uBAAuB;EACvB,wBAAwB;EACxB,iCAAiC;EACjC,6BAA6B;EAC7B,mDAAmD,EAAE,gCAAgC;AACvF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,eAAe,EAAE,8BAA8B;EAC/C,YAAY,EAAE,eAAe;AAC/B;;AAEA;EACE,yBAAyB,EAAE,2CAA2C;EACtE,8BAA8B,EAAE,gCAAgC;EAChE,YAAY,EAAE,oBAAoB;AACpC;;AAEA;EACE,oCAAoC,EAAE,iCAAiC;EACvE,uBAAuB,EAAE,qBAAqB;AAChD;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B,EAAE,kCAAkC;AACnE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,eAAe,EAAE,+CAA+C;EAChE,gBAAgB,EAAE,yBAAyB;EAC3C,YAAY,EAAE,mCAAmC;AACnD;;AAEA;EACE,oCAAoC,EAAE,iCAAiC;EACvE,uBAAuB,EAAE,qBAAqB;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB,EAAE,iCAAiC;AACxD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB,EAAE,yBAAyB;AAC7C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,YAAY;AACd","sourcesContent":[".sidebar {\n  width: 240px !important;\n  background-color: #2c3e50 !important; /* Dark blue from the HTML version */\n  color: white !important; /* White text for better contrast on dark background */\n  height: 100% !important;\n  display: flex !important;\n  flex-direction: column !important;\n  position: relative !important;\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1) !important; /* Add subtle shadow for depth */\n}\n\n.sidebar .logo {\n  padding: 20px;\n  text-align: center;\n  background-color: #2c3e50 !important;\n}\n\n.sidebar .logo img {\n  max-width: 100%;\n}\n\n.nav-options {\n  padding: 20px 0;\n}\n\n.nav-option {\n  padding: 12px 20px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  font-size: 16px; /* Ensure readable font size */\n  color: white; /* White text */\n}\n\n.nav-option.active {\n  background-color: #34495e; /* Darker blue for active state from HTML */\n  border-left: 4px solid #3498db; /* Blue accent color from HTML */\n  color: white; /* Keep text white */\n}\n\n.nav-option:hover {\n  background-color: #34495e !important; /* Force darker blue background */\n  color: white !important; /* Force white text */\n}\n\n.profile-section {\n  margin-top: auto;\n  padding: 20px;\n  border-top: 1px solid #34495e; /* Darker border color from HTML */\n}\n\n.profile-option {\n  display: flex;\n  align-items: center;\n  padding: 12px 0;\n  cursor: pointer;\n  font-size: 18px; /* Increased font size for better readability */\n  font-weight: 500; /* Slightly bolder text */\n  color: white; /* White text for dark background */\n}\n\n.profile-option:hover {\n  background-color: #34495e !important; /* Force darker blue background */\n  color: white !important; /* Force white text */\n}\n\n.profile-option img {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  margin-right: 12px;\n}\n\n.profile-menu-dropdown {\n  position: absolute;\n  bottom: 80px;\n  right: 20px;\n  background-color: #34495e;\n  border-radius: 4px;\n  padding: 8px 0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.menu-item {\n  padding: 8px 16px;\n  color: white;\n  cursor: pointer;\n}\n\n.menu-item:hover {\n  background-color: #2c3e50;\n}\n\n.change-password-modal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  z-index: 1000;\n  width: 300px;\n  color: #2c3e50;\n}\n\n.change-password-modal input {\n  display: block;\n  width: 100%;\n  padding: 8px;\n  margin: 8px 0;\n  border-radius: 4px;\n  border: 1px solid #ddd;\n  margin-bottom: 16px; /* Added spacing between fields */\n}\n\n.change-password-modal h3 {\n  margin-top: 0;\n  margin-bottom: 20px;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 24px; /* Increased top margin */\n}\n\n.primary-button {\n  background-color: #3498db;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.primary-button:hover {\n  background-color: #2980b9;\n}\n\n.secondary-button {\n  background-color: white;\n  color: #2c3e50;\n  border: 1px solid #ddd;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.secondary-button:hover {\n  background-color: #f5f5f5;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
